import { render, staticRenderFns } from "./like.vue?vue&type=template&id=15b2bd83&scoped=true&"
import script from "./like.vue?vue&type=script&lang=js&"
export * from "./like.vue?vue&type=script&lang=js&"
import style0 from "./like.vue?vue&type=style&index=0&id=15b2bd83&prod&lang=css&"
import style1 from "./like.vue?vue&type=style&index=1&id=15b2bd83&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2bd83",
  null
  
)

export default component.exports